export const sectionType = {
  sectionFreestyle: 'section-freestyle',
  sectionBanner: 'section-banner',
  sectionBannerHsia: 'section-banner-hsia',
  sectionBannerKynorelle: 'section-banner-kynorelle',
  sectionGridItemKynorelle: 'section-grid-item-kynorelle',
  sectionGridItemKynorelle02: 'section-grid-item-kynorelle-02',
  sectionGridItemKynorelle03: 'section-grid-item-kynorelle-03',
  sectionGridItemKynorelle04: 'section-grid-item-kynorelle-04',
  sectionGridItemKynorelle05: 'section-grid-item-kynorelle-05',
  sectionMarkqueueKynorelle: 'section-markqueue-kynorelle',
  sectionMarqueeKyroro: 'section-marquee-kyroro',
  sectionMarqueeBoxerItem: 'section-marquee-boxer-item',
  sectionCardSona: 'section-card-sona',
  sectionCustomizeCard: 'section-customize-card',
  sectionCardCigar: 'section-card-cigar',
  sectionCardKynorelle: 'section-card-kynorelle',
  sectionCardHsiaGrid: 'section-card-hsia-grid',
  sectionCardReviewHsiaGrid: 'section-card-review-hsia-grid',
  sectionCardHsiaCategory: 'section-card-hsia-category',
  sectionCardHsiaTags: 'section-card-hsia-tags',
  sectionCardHsiaTextWithIcon: 'section-card-hsia-text-with-icon',
  sectionCardFaqKynorelle: 'section-card-faq-kynorelle',
  sectionSliderReviewKynorelle: 'section-slider-review-kynorelle',
  sectionCardVideo: 'section-card-video',
  sectionCardVideoSlider: 'section-card-video-slider',
  sectionProducts: 'section-products',
  sectionTextWithIcon: 'section-text-with-icon',
  sectionSliderItemFyroro: 'section-slider-item-fyroro',
  sectionSliderItemBoxer: 'section-slider-item-boxer',
  sectionProductWithVariant: 'section-product-with-variant',
  sectionCardGridBoxer: 'section-card-grid-boxer',
  sectionCardWithTabsBoxer: 'section-card-with-tabs-boxer',
  sectionCardMultiBoxer: 'section-card-multi-boxer',
  sectionCardReviewsBoxer: 'section-card-reviews-boxer',
  sectionSliderBoxerProduct: 'section-slider-boxer-product',
  sectionImageWithTextConvenFeet01: 'section-image-with-text-conven-feet-01',
  sectionImageWithTextConvenFeet02: 'section-image-with-text-conven-feet-02',
  sectionImageWithTextConvenFeet03: 'section-image-with-text-conven-feet-03',
  sectionIconGridWithHeroTextConvenFeet: 'section-icon-grid-with-hero-text-conven-feet',
  sectionCalyrafitBanner: 'section-calyrafit-banner',
  sectionCalyrafitMarquee01: 'section-calyrafit-marquee-01',
  sectionCalyrafitMarquee: 'section-calyrafit-marquee',
  sectionCalyrafitGirdImage: 'section-calyrafit-gird-image',
  sectionCalyrafitBestSaller: 'section-calyrafit-best-saller',
  sectionCalyrafitSideBySide: 'section-calyrafit-side-by-side',
  sectionCalyrafitSlide: 'section-calyrafit-slide',
  sectionCalyrafitCollections: 'section-calyrafit-collections',
  sectionCalyrafitTextWithIcon: 'section-calyrafit-text-with-icon',
  sectionCalyrafitReview: 'section-calyrafit-review',
  sectionCalyrafitFooter: 'section-calyrafit-footer',
  sectionCeflorecoBanner1: 'section-cefloreco-banner-1',
  sectionCeflorecoProductWorld: 'section-cefloreco-product-world',
  sectionCeflorecoBanner2: 'section-cefloreco-banner-2',
  sectionCeflorecoTextGradient: 'section-cefloreco-text-gradient',
  sectionCeflorecoSideBySide: 'section-cefloreco-side-by-side',
  sectionCeflorecoMobileApp: 'section-cefloreco-mobile-app',
  sectionCeflorecoBenefis: 'section-cefloreco-benefis',
  sectionCeflorecoLetsTalk: 'section-cefloreco-lets-talk',
  sectionCeflorecoFooter: 'section-cefloreco-footer',
};
